import type { CandidateEvent, CandidateMarket } from '../model/types';

export interface LeadingOutcome {
    market: CandidateMarket;
    label: string;
}

export function leadingOutcome(event: CandidateEvent): LeadingOutcome | null {
    if (event.markets.length === 0) return null;
    if (event.markets.length === 1) {
        return { market: event.markets[0], label: 'Yes' };
    }
    let best = event.markets[0];
    for (const market of event.markets) {
        if ((market.probability ?? -1) > (best.probability ?? -1)) {
            best = market;
        }
    }
    return { market: best, label: best.label };
}
